import * as React from "react";

function PersonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m315.1 271-70.56-112.1C232.8 139.3 212.5 128 190.3 128h-60.6c-22.22 0-42.53 11.25-54.28 30.09L4.873 271c-9.375 14.98-4.812 34.72 10.16 44.09 15 9.375 34.75 4.812 44.09-10.19l28.88-46.18L87.1 480c0 17.67 14.33 32 32 32s31.1-14.33 31.1-32V336h16v144c0 17.67 14.33 32 32 32s32-14.33 32-32V258.8l28.88 46.2c7.82 9.7 18.32 15 28.92 15 5.781 0 11.66-1.562 16.94-4.859C319.9 305.8 324.5 286 315.1 271zM160 96c26.5 0 48-21.5 48-48S186.5 0 160 0s-48 21.5-48 48 21.5 48 48 48z"
  }));
}

const ForwardRef = React.forwardRef(PersonIcon);
export default ForwardRef;